import { RichTextAreaMethods } from './types';

class RichTextAreaStore {
  private static instance: RichTextAreaStore;
  private refs: Map<string, RichTextAreaMethods>;

  private constructor() {
    this.refs = new Map();
  }

  public static getInstance(): RichTextAreaStore {
    if (!RichTextAreaStore.instance) {
      RichTextAreaStore.instance = new RichTextAreaStore();
    }
    return RichTextAreaStore.instance;
  }

  // 注册富文本组件的 ref
  register(id: string, ref: RichTextAreaMethods) {
    this.refs.set(id, ref);
  }

  // 注销富文本组件的 ref
  unregister(id: string) {
    this.refs.delete(id);
  }

  // 获取富文本组件的 ref
  getRef(id: string): RichTextAreaMethods | undefined {
    return this.refs.get(id);
  }

  // 获取所有富文本组件的 ref
  getAllRefs(): Map<string, RichTextAreaMethods> {
    return this.refs;
  }
}

export const richTextAreaStore = RichTextAreaStore.getInstance();
